import React, { Dispatch, SetStateAction } from "react";
import { Editor } from "@tinymce/tinymce-react";

interface RichTextEditorProps {
  htmlContent: string;
  setHtmlContent: Dispatch<SetStateAction<string>>;
}

const RichTextEditor = ({
  htmlContent,
  setHtmlContent,
}: RichTextEditorProps) => {
  const handleModelChange = (model: string) => {
    setHtmlContent(model);
  };

  return (
    <Editor
      value={htmlContent}
      tinymceScriptSrc="/tinymce/js/tinymce/tinymce.min.js"
      init={{
        menubar: false,
        statusbar: false,
        plugins: [
          "advlist",
          "autolink",
          "link",
          "code",
          "fullscreen",
          "preview",
          // "textcolor",
          // "colorpicker",
          "anchor",
          "media",
          "autoresize",
          // "fontsize",
          "emoticons",
          "charmap",
          "table",
          "codesample",
          "searchreplace",
          "wordcount",
        ],
        toolbar: `
          undo redo | bold italic underline strikethrough | copy cut searchreplace | alignleft aligncenter alignright |
          outdent indent | link table | subscript superscript | emoticons charmap codesample | code fullscreen preview wordcount
        `,
        toolbar_mode: "wrap",
        toolbar_sticky: true,
        fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt 48pt",
        autoresize_bottom_margin: 20,
        autoresize_min_height: 200,
        autoresize_max_height: 1000,
        highlight_on_focus: false,
        object_resizing: false,
      }}
      onEditorChange={handleModelChange}
    />
  );
};

export default React.memo(RichTextEditor);
